export default {
    LOAD_LEAD(state, lead) {
        state.items = lead;
    }
}